var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { attrs: { id: _vm.id } }, [
        _vm.mapboxError ? _c("div", [_vm._v("Errore")]) : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "loader-overlay loader-overlay-map",
          class: { "is-hidden": !_vm.loading }
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _vm._t("extra")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ripple" }, [_c("div"), _c("div")])
  }
]
render._withStripped = true

export { render, staticRenderFns }